define("settings/controllers/groups/group/members/edit", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency", "later/models/membership"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _tracking, _emberConcurrency, _membership) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/models/membership"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let EditController = _exports.default = (_class = class EditController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "isApprover", _descriptor5, this);
      _initializerDefineProperty(this, "canPublishWithoutApproval", _descriptor6, this);
      _initializerDefineProperty(this, "showReviewerRoleModal", _descriptor7, this);
      _initializerDefineProperty(this, "showWithoutReviewModal", _descriptor8, this);
      _defineProperty(this, "saveMembership", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            if (this.isApprover) {
              this.model.approverRole = _membership.ApproverRole.Approver;
            } else if (this.canPublishWithoutApproval) {
              this.model.approverRole = _membership.ApproverRole.Editor;
            } else {
              this.model.approverRole = _membership.ApproverRole.NeedsApproval;
            }
            yield this.model.save();
            const role = this.model.approverRole || _membership.ApproverRole.Editor;
            // TODO: Update copy for needs_approval and editor role changes
            const title = this.intl.t(`approval.settings.edit_roles_modal.toggle.${role}.title`, {
              name: this.model.name
            });
            const message = this.intl.t(`approval.settings.edit_roles_modal.toggle.${role}.message`);
            this.alerts.success(message, {
              title
            });
            this.closeModal();
          } catch (error) {
            this.model.rollbackAttributes();
            this.errors.log(error);
            this.alerts.warning(this.intl.t('alerts.errors.generic'));
          }
        }
      }), null, "saveMembership", null));
    }
    closeModal() {
      this.router.transitionTo('account.groups.group.members');
    }
    validateRole() {
      if (!this.isApprover) {
        this.canPublishWithoutApproval = true;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isApprover", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "canPublishWithoutApproval", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showReviewerRoleModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "showWithoutReviewModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateRole", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "validateRole"), _class.prototype)), _class);
});